import { StemTextInline, StemTextGapMatch, Stem } from "@examspark/types";

type SortedGapArrays = {
  content: Stem.Gaps[];
  scoring: Stem.ScoringGaps[];
};

export const getSortedGapArrays = (
  stem: StemTextInline | StemTextGapMatch,
): SortedGapArrays => {
  const output: SortedGapArrays = {
    content: [],
    scoring: [],
  };
  if (!stem.scoring || !stem.scoring.gaps) {
    return output;
  }

  const matches = stem.content.text?.body
    ?.match(/data-gap-id="(.*?)"/g)
    ?.map((x) => x.replace(/data-gap-id="|"/g, ""));

  if (!matches) {
    return output;
  }

  for (const match of matches) {
    if (match in stem.content.gaps) {
      output.content.push({ [match]: stem.content.gaps[match] });
    }
    if (match in stem.scoring.gaps) {
      output.scoring.push({ [match]: stem.scoring.gaps[match] });
    }
  }

  return output;
};
